import React from "react";
import { Briefcase, MessageCircleHeart, MessageSquare } from "lucide-react";
import { useIntl } from "react-intl";
import "./ConversationToneToggle.scss"

const tones = {
    professional: { icon: Briefcase, className: "professional" },
    casual: { icon: MessageCircleHeart, className: "casual" },
};

const fallback = { icon: MessageSquare, className: "default" };

const ConversationToneToggle = ({ tone, onChange, toneKeys }) => {
    const intl = useIntl();

    if (!toneKeys || toneKeys.length === 0) return null;

    const currentIndex = toneKeys.indexOf(tone);
    const resolvedIndex = currentIndex !== -1 ? currentIndex : 0;
    const currentKey = toneKeys[resolvedIndex];
    const { icon: IconComponent, className } = tones[currentKey] || fallback;

    const handleToggle = () => {
        const nextIndex = (resolvedIndex + 1) % toneKeys.length;
        onChange(toneKeys[nextIndex]);
    };

    const label = intl.formatMessage({
        id: `bot.tone.${currentKey}`,
        defaultMessage: currentKey,
    });

    return (
        <div
            className={`tone-toggle tone-toggle--${className}`}
            onClick={handleToggle}
            aria-label={label}
        >
            <IconComponent size={18} />
            <span className="tone-toggle__label">{label}</span>
        </div>
    );
};

export function getDefaultToneForSegment(customerSegment) {
    const casualSegments = ["VOC", "HS"];
    return casualSegments.includes(customerSegment) ? "casual" : "professional";
}

export default ConversationToneToggle;
